var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ooliba-basic-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.busy,"no-pagination":""},on:{"row-clicked":_vm.onRowClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }